import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { TypeOfLuggage, WeightLuggageType } from '@shared/luggage/constants/type-luggage';
import { getLuggageConditions } from '@shared/luggage/mappers/luggage-conditions.mapper';

@Pipe({
  name: 'typeLuggage',
  standalone: false
})
export class TypeLuggagePipe implements PipeTransform {

  transform(value: string): TypeOfLuggage {
    if (!isEmpty(value)) {
      const luggageConditions = getLuggageConditions(value);
      if (!isEmpty(luggageConditions[0])) {
        const condition = luggageConditions[0];
        const isByWeightType = condition.includes(WeightLuggageType.KG);
        return isByWeightType ? TypeOfLuggage.ByWeight : TypeOfLuggage.ByPieces;
      } else return TypeOfLuggage.ByPieces;
    } else return TypeOfLuggage.ByPieces;
  }

}
